import React, { useState } from "react";
import { db } from "../firebase"; // Import Firebase
import { collection, addDoc } from "firebase/firestore";

const CreateYourOwnTrip = () => {
  const [formData, setFormData] = useState({
    destination: "",
    priceRange: "",
    peopleCategory: "",
    touristGuide: "",
    additionalNotes: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      await addDoc(collection(db, "trips"), formData);
      setSuccessMessage("تم إنشاء اقتراح الرحلة بنجاح!");
      setFormData({
        destination: "",
        priceRange: "",
        peopleCategory: "",
        touristGuide: "",
        additionalNotes: "",
      });
    } catch (error) {
      console.error("Error adding trip: ", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="container mx-auto flex flex-col justify-center  w-full h-screen">
      <h1 className="text-4xl font-bold text-center  text-blue-700 mb-10">أنشئ رحلتك الخاصة</h1>
      <form
        onSubmit={handleSubmit}
        className="bg-white shadow-lg rounded-lg max-w-md mx-auto w-full p-6"
      >
        <div className="mb-4">
          <label htmlFor="destination" className="block text-sm font-medium text-gray-700">
            الوجهة
          </label>
          <input
            type="text"
            id="destination"
            name="destination"
            value={formData.destination}
            onChange={handleChange}
            required
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
          />
        </div>

        <div className="mb-4">
          <label htmlFor="priceRange" className="block text-sm font-medium text-gray-700">
            نطاق السعر (مثل: 1000$ - 2000$)
          </label>
          <input
            type="text"
            id="priceRange"
            name="priceRange"
            value={formData.priceRange}
            onChange={handleChange}
            required
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
          />
        </div>

        <div className="mb-4">
          <label htmlFor="peopleCategory" className="block text-sm font-medium text-gray-700">
            فئة الأشخاص
          </label>
          <select
            id="peopleCategory"
            name="peopleCategory"
            value={formData.peopleCategory}
            onChange={handleChange}
            required
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
          >
            <option value="">اختر فئة</option>
            <option value="Family">عائلة</option>
            <option value="Couple">زوجان</option>
            <option value="Solo">فرد</option>
            <option value="Group">مجموعة</option>
          </select>
        </div>

        <div className="mb-4">
          <label htmlFor="touristGuide" className="block text-sm font-medium text-gray-700">
            تفضيلات دليل سياحي
          </label>
          <input
            type="text"
            id="touristGuide"
            name="touristGuide"
            value={formData.touristGuide}
            onChange={handleChange}
            required
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
          />
        </div>

        <div className="mb-4">
          <label htmlFor="additionalNotes" className="block text-sm font-medium text-gray-700">
            ملاحظات إضافية
          </label>
          <textarea
            id="additionalNotes"
            name="additionalNotes"
            value={formData.additionalNotes}
            onChange={handleChange}
            rows={4}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
          />
        </div>

        <button
          type="submit"
          disabled={isSubmitting}
          className="w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 disabled:opacity-50"
        >
          {isSubmitting ? "جارٍ الإرسال..." : "إنشاء الرحلة"}
        </button>
      </form>

      {successMessage && (
        <div className="mt-4 p-4 bg-green-100 text-green-800 rounded-lg">
          {successMessage}
        </div>
      )}
    </div>
  );
};

export default CreateYourOwnTrip;
